import { createSlice } from "@reduxjs/toolkit";
const string = sessionStorage.getItem("navigate");


const initialState = {
  string: string === "" ? "" : string,
  success: false,
  failure: false,
  information: false,
  update_success: false,
  update_failure: false,
  delete_success: false,
  password_success: false,
  password_failure: false,
  top: "bottom",
  center: "center",
  apiLoad: false,
  delete_failure: false
};

export const sidebarReducerInner = createSlice({
  name: "sidebar",

  initialState: initialState,
  reducers: {
    stringUpdate(state, action) {
      state.string = action.payload;
    },
    // pop up msg for adding Data
    success(state, action) {
      state.success = action.payload;
    },
    // Failure msg on editing data
    failure(state, action) {
      state.failure = action.payload;
    },
    // if the data is already present
    information(state, action) {
      state.information = action.payload;
    },
    // pop up msg for updating Data
    update_success(state, action) {
      state.update_success = action.payload;
    },
    // Failure msg on updating data
    update_failure(state, action) {
      state.update_failure = action.payload;
    },
    // success msg on deleting data
    delete_success(state, action) {
      state.delete_success = action.payload;
    },
    delete_failure(state, action) {
      state.delete_failure = action.payload;
    },
    // success msg on password update
    password_success(state, action) {
      state.password_success = action.payload;
    },
    // failure msg on password update
    password_failure(state, action) {
      state.password_failure = action.payload;
    },
    // spinner for loading
    apiLoad(state, action) {
      state.apiLoad = action.payload;
    },
  },
});
